
import '../../styles/CAS.css';

/*Iconos*/
import Casco_icon from '../../imagenes/icons/casco.gif';
import Bases_icon from '../../imagenes/icons/bases.gif';
import Anexos_icon from '../../imagenes/icons/anexos.gif';
import Comunicado_icon from '../../imagenes/icons/comunicado.gif';
import FeErratas_icon from '../../imagenes/icons/feErratas.gif';
import EvaCV_icon from '../../imagenes/icons/evaluacion.gif';
import Entrevista_icon from '../../imagenes/icons/entrevista.gif';
import ResultFinal_icon from '../../imagenes/icons/resultados.gif';

/*Documentos*/
import Bases_pdf from '../../documentos/CAS/CASV2026/BASES_CAS_N_005_2026.pdf';
import Anexos_doc from '../../documentos/CAS/CASV2026/ANEXOS_-_CAS_005-2026.docx';
import Comunicado_01_pdf from '../../documentos/CAS/CASIV2026/COMUNICADO_01_-_CAS_4.pdf';
import Comunicado_02_pdf from '../../documentos/CAS/CASIII2025/COMUNICADO_CAS_III_02_2025.pdf';
import Fe_Erratas_01_pdf from '../../documentos/CAS/CASIV2026/FE_DE_ERRATAS_CAS_IV_01_2026.pdf';
import Fe_Erratas_02_pdf from '../../documentos/CAS/CASIV2025/FE_DE_ERRATAS_02_2025.pdf';
import Result_CV_pdf from '../../documentos/CAS/CASIV2026/RESULTADOS_DE_EVALUACION_CURRICULAR_04_2026.pdf';
import Cronograma_pdf from '../../documentos/CAS/CASIV2026/CRONOGRAMA_DE_ENTREVISTA_04_2026.pdf';
import ResultFinal_pdf from '../../documentos/CAS/CASIV2026/RESULTADOS_FINALES_-_CAS_IV_-_2026.pdf';

function CASIII2025(){
  const documentos=[
    {
      titulo: 'Bases Convocatoria V CAS 2026',
      icon: Bases_icon,
      nombre: 'Ver Documento',
      url: Bases_pdf,
    },
     {
      titulo: 'Anexos',
      icon: Anexos_icon,
      nombre: 'Ver Anexos',
      url: Anexos_doc,
    },  
    
  ];
  return(
    <section className='cas-section'>
      <div className='titulo-cas'>
        <img src={Casco_icon} className='titulo-icon'></img>
        <h2>CAS Nº005-2026-MPCH</h2>
      </div>
      <p className='subtitulo'>Bases del Concurso para Contratación de Personal</p>
      <div className='cas-grid'>
        {documentos.map((doc, index) => (
          <div className='cas-card' key={index}>
            <img src={doc.icon} className='doc-icon'></img>
            <h3>{doc.titulo}</h3>
            <a
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            >
            {doc.nombre}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
export default CASIII2025;